import { typeArticleMainGroup } from "./articleMainGroup"
import { queryArticleMainGroup } from "./queries/queryArticleMainGroup"
import { queryArticleMainGroups } from "./queries/queryArticleMainGroups"

const articleMainGroupSchema = {
  types: [typeArticleMainGroup],
  resolvers: {
    Query: {
      ...queryArticleMainGroups,
      ...queryArticleMainGroup,
    },
    Mutation: {},
  },
}

export default articleMainGroupSchema
